import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../../helpers/ApiCall';
import apiRoot from '../../consts/apiRoot';
import {
  FETCH_SINGLE_CONVERSATION,
  FETCH_SINGLE_CONVERSATION_SUCCESS,
  FETCH_SINGLE_CONVERSATION_FAIL
} from '../../redux/Conversations';

function* fetchSingleConversationFlow({ payload: { id, hashId, }, }) {
  try {
    const endpoint = `${apiRoot}/conversations/${id}`;
    const data = yield call(apiCall, { method: 'GET', endpoint, });
    yield put(FETCH_SINGLE_CONVERSATION_SUCCESS({ data, hashId, }));
  } catch (error) {
    yield put(FETCH_SINGLE_CONVERSATION_FAIL(error));
  }
}

export default function* FetchSingleConversation() {
  yield takeLatest(FETCH_SINGLE_CONVERSATION, fetchSingleConversationFlow);
}
